import { useBackend } from "../../services";

export const useRegisterPasskey = () => {
  const { post } = useBackend();
  return async (attestationObject: string) => {
    return await post("passkeys/registration", attestationObject);
  };
};
